







































import {fromEvent, interval, merge} from "rxjs"
import {map, debounce} from "rxjs/operators"
import StateComments from "@/components/StateComments.vue"
import tools from "@/tools.coffee"

export default {
    "name": "StateSignalingWriting"
    "components": {StateComments}
    "props": {
        "context": {
            "type": Object
            "required": true
        }
        "human_created_on": String
        "email_set" : Array
    }
    "data": ()->
        return {
            "content": null,
            "text$": null,
            "mhr_note$": null,
        }
    "methods":
        "update_data": (comments)->
            console.log("update data", @content)
            @content.data.comments = comments
            @$emit("state:update_data", @content.data)

        "delete_state": ()->
            @$emit("state:delete_state")
    "computed":
        "hasSentEmail": ()->
            return @email_set.length > 0 && @email_set.some((email) => email.sent_on != null && email.sent_on != '');
    "mounted": ()->
        self = @
        text_stream = fromEvent(self.$refs.text, "input")
        mhr_note_stream = fromEvent(self.$refs.mhr_note, "input")
        updates_stream = merge(text_stream, mhr_note_stream).pipe(
            debounce(() -> interval(500))
        )
        updates_stream.subscribe(
            (event) ->
                console.log("value", event)
                self.update_data(self.content.data.comments)
        )
    "created": ()->
        self = @
        @content = @context
        # live update for comments
        self.$djangows['onmodelsignals']({"modelName": "state", "appLabel": "state"}, (event)->
            if event.obj?
                # console.log("state event", event, self.content.review.uid, event.obj.review)
                # if event.obj.review == self.content.review.uid
                if event.obj.uid == self.content.uid
                    if event.signal_type == "post_save" and event.created == false
                        self.content.data.comments = event.obj.data.comments
                        # @$emit("state:update_data", @content.data)
        )
}
